import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${props => props.theme.colors.secondary(0.1)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 20px;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    flex-direction: row;
    padding: 40px 20px;
  }

  > div + div {
    @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
      margin-top: 20px;
    }

    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      margin-left: 20px;
    }
  }

  > div:last-child {
    @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
      margin-top: 10px;
    }
  }
`;
